import { EmptyState } from 'components/EmptyState'
import { observer } from 'mobx-react'
import React from 'react'
import Spinner from '../../../../../../../../components/Spinner'

export default observer(function OCRScopeJobScopingInProgress() {
  return (
    <EmptyState
      image={<Spinner size={80} thickness={4} />}
      title={'OCR is processing'}
      subtitle={<span>Please check back again in a few minutes.</span>}
      animate
      small
    />
  )
})
